function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "link",
  transform: "translate(-919.823 -331.265)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_16451",
  "data-name": "Group 16451",
  transform: "translate(915.369 331.668)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_55",
  "data-name": "Group 55",
  transform: "translate(4.866 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_54",
  "data-name": "Group 54",
  transform: "translate(0.087 0.093)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_168",
  "data-name": "Path 168",
  d: "M556.319,314.107H534.233a2.763,2.763,0,0,1-2.763-2.763v-30.57a2.763,2.763,0,0,1,2.763-2.763h14.007l10.842,11.176v22.158A2.763,2.763,0,0,1,556.319,314.107Z",
  transform: "translate(-531.47 -278.006)",
  fill: "#fefeff",
  stroke: "#bbbdbf",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_169",
  "data-name": "Path 169",
  d: "M578.26,278v8.6a2.57,2.57,0,0,0,2.57,2.57H589.1L578.26,278Z",
  transform: "translate(-561.489 -278)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_170",
  "data-name": "Path 170",
  d: "M578.564,304.12a2.862,2.862,0,0,0,2.265,2.774,2.316,2.316,0,0,0,.272.061c1.079.194,8.19,1.459,8.19,1.294v-2.312h-8.272s-2.065-.072-2.459-1.817Z",
  transform: "translate(-561.682 -294.758)",
  fill: "#bbbdbf"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_171",
  "data-name": "Path 171",
  d: "M556.163,313.934a2.955,2.955,0,0,0,.477-.057,2.793,2.793,0,0,0,1.255-.584,2.736,2.736,0,0,0,.989-1.95c.014-.892,0-1.925,0-3.079-.007-4.627-.018-11.251-.032-19.251l.022.054L548.023,277.9l.065.029H534.7a6.916,6.916,0,0,0-1.061.039,2.681,2.681,0,0,0-1.735,1.082,2.635,2.635,0,0,0-.487,1.358c-.018.491-.007,1-.011,1.5v8.814c0,3.821,0,7.509-.007,11.022q0,2.634,0,5.133v3.66a6.517,6.517,0,0,0,.05,1.161,2.7,2.7,0,0,0,1.251,1.778,2.625,2.625,0,0,0,1.018.358c.355.043.728.021,1.086.029,1.448,0,2.842,0,4.168.007,5.308.011,9.606.022,12.581.029l3.419.018c.387,0,.685.007.889.011s.3.011.3.011-.1.007-.3.011-.5,0-.889.011l-3.419.018c-2.975.007-7.272.018-12.581.029q-1.995,0-4.168.007a10.534,10.534,0,0,1-1.108-.029,2.839,2.839,0,0,1-2.4-2.251,6.355,6.355,0,0,1-.057-1.194v-3.66q0-2.495,0-5.133c0-3.513,0-7.2-.007-11.022v-8.814c0-.5-.011-1,.011-1.513a2.823,2.823,0,0,1,.523-1.455,2.865,2.865,0,0,1,1.857-1.158,7.488,7.488,0,0,1,1.09-.043h13.423l.025.029c3.9,4.029,7.556,7.8,10.835,11.183l.021.022v.032c-.014,8-.025,14.624-.032,19.251-.007,1.158,0,2.186-.018,3.086a2.77,2.77,0,0,1-1.029,1.982,2.721,2.721,0,0,1-1.28.57,2.341,2.341,0,0,1-.358.032h-.122Z",
  transform: "translate(-531.226 -277.74)",
  fill: "#bbbdbf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_172",
  "data-name": "Path 172",
  d: "M588.939,289.186a1.381,1.381,0,0,1-.211.018c-.161,0-.362.011-.609.018-.555.007-1.312.018-2.24.029-.953.007-2.079.011-3.323.018h-1.964a2.668,2.668,0,0,1-1.921-.9,2.625,2.625,0,0,1-.541-.957,3.15,3.15,0,0,1-.122-1.054c0-.681,0-1.337.007-1.964.007-1.244.014-2.369.022-3.323.011-.928.022-1.688.029-2.24.007-.247.014-.448.018-.609a.972.972,0,0,1,.018-.211.744.744,0,0,1,.018.211l.018.609c.007.556.018,1.312.029,2.24.007.953.011,2.079.021,3.323,0,.627,0,1.283.007,1.964a2.942,2.942,0,0,0,.115,1,2.53,2.53,0,0,0,.505.889,2.473,2.473,0,0,0,1.785.842c.677,0,1.333.007,1.961.011l3.323.022c.928.011,1.688.022,2.24.029.247.007.448.014.609.018a.971.971,0,0,1,.212.018Z",
  transform: "translate(-561.239 -277.913)",
  fill: "#bbbdbf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_29408",
  "data-name": "Path 29408",
  d: "M550.543,289.286a1.376,1.376,0,0,0,.211.018l.663.018c.556.007,11.1-.082,12.031-.072.953.007,2.079.011,3.323.018h1.964a2.668,2.668,0,0,0,1.921-.9,2.626,2.626,0,0,0,.541-.957,3.153,3.153,0,0,0,.122-1.054c0-.681,0-1.337-.007-1.964-.007-1.244-.014-2.369-.021-3.323-.011-.928-.021-1.688-.029-2.24-.007-.247-.014-.448-.018-.609a.969.969,0,0,0-.018-.211.746.746,0,0,0-.018.211l-.018.609c-.007.556-.018,1.312-.029,2.24-.007.953-.011,2.079-.022,3.323,0,.627,0,1.283-.007,1.964a2.945,2.945,0,0,1-.115,1,2.531,2.531,0,0,1-.505.889,2.473,2.473,0,0,1-1.785.842c-.677,0-1.333.007-1.961.011-1.244.007-2.369.014-3.323.022-.928.011-11.479.122-12.031.129l-.663.018a.972.972,0,0,0-.211.018Z",
  transform: "translate(-543.534 -253.074)",
  fill: "#a0a0a0"
}))), /*#__PURE__*/React.createElement("g", {
  id: "link-2",
  "data-name": "link",
  transform: "translate(917.6 341.033)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31734",
  "data-name": "Path 31734",
  d: "M20.975,15.538l1.7,1.7,3.4-3.4a4.806,4.806,0,0,0-6.8-6.8l-3.4,3.4,1.7,1.7,3.4-3.4a2.4,2.4,0,0,1,3.4,3.4Z",
  transform: "translate(-3.845 0)",
  fill: "#3b8de0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31735",
  "data-name": "Path 31735",
  d: "M15.538,20.977l1.7,1.7-3.4,3.4a4.806,4.806,0,0,1-6.8-6.8l3.4-3.4,1.7,1.7-3.4,3.4a2.4,2.4,0,0,0,3.4,3.4l3.4-3.4Z",
  transform: "translate(0 -3.845)",
  fill: "#3b8de0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31736",
  "data-name": "Path 31736",
  d: "M20.467,15.369a1.2,1.2,0,1,0-1.7-1.7l-5.1,5.1a1.2,1.2,0,1,0,1.7,1.7l5.1-5.1Z",
  transform: "translate(-2.433 -2.432)",
  fill: "#3b8de0"
})));

function SvgOtherTypes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.613,
    height: 37.097,
    viewBox: "0 0 28.613 37.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTypes);
export default __webpack_public_path__ + "static/media/other-types.b63f859b.svg";
export { ForwardRef as ReactComponent };